import ProductFamily from 'Vue/containers/ProductFamily.vue';

// @ts-ignore
import { createApp } from "vue";
import Toast, { PluginOptions } from "vue-toastification";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.addVueApp = function () {
	const options: PluginOptions = {
		transition: "Vue-Toastification__bounce",
		maxToasts: 20,
		newestOnTop: true
	};

	const pf = createApp(ProductFamily).use(Toast, options);
	pf.mount("#productFamily");
};

module.init = function () {
	module.addVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
